<div #hostElement [class.visibility-hidden]="isLoading | async" class="image-container">
    <canvas #heatmapCanvas></canvas>
    <img #imageRef [src]="img" alt="Heatmap Image" style="display:none;"/>
</div>

<div *ngIf="isLoading | async" class="d-flex flex-center align-items-center loader-container">
    <mat-spinner></mat-spinner>
</div>
